<script setup>
import footers from '@/components/main/footer/footer.vue' // 页脚
import footerTow from '@/components/main/footer/footerTow.vue' // 页脚2

import contact from '@/components/main/sideEdge/contact.vue' // 侧边联系方式


import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据



const HeziyunData = ref(parseHeziyunData())

console.log(HeziyunData.value)

</script>

<template>
    <!-- 侧边 -->
    <contact :theme="HeziyunData.theme.side" v-if="HeziyunData.theme.side == '1'"></contact>

    <!-- 页脚 -->
    <footers :common="HeziyunData.global" :friend="HeziyunData.friend" v-if="HeziyunData.theme.footer == '1'"></footers>
    <footerTow :common="HeziyunData.global" :friend="HeziyunData.friend" v-if="HeziyunData.theme.footer == '2'"></footerTow>
</template>